import { ACTIVE_TAB_CHANGED } from '../../app-settings/actions/active-tab-changed';
import { BUTTON_CLICKED } from '../../app/actions/button-clicked';
import { DELETE_CATEGORY_REQUEST } from '../../app/actions/delete-category';
import { FORUM_RENAMED } from '../../app-settings/actions/forum-renamed';
import { FORUM_RENAME_STARTED } from '../../app-settings/actions/forum-rename-started';
import { LAYOUT_CHANGED } from '../../app-settings/actions/layout-changed';
import { SET_ACTIVE_DESIGN_PAGE } from '../../app-settings/actions/set-active-design-page';
import { SHOW_FORUM_FORM } from '../../app-settings/actions/show-forum-form';
import { CATEGORY_EDITED } from '../../app-settings/actions/category-edited';
import { CATEGORY_RENAMED } from '../../app-settings/actions/category-renamed';
import { CATEGORY_RENAME_STARTED } from '../../app-settings/actions/category-rename-started';
import { TEXTBOX_CHANGED } from '../../app-settings/actions/textbox-changed';
import { biTabNames } from '../../app-settings/constants';
import { designTabNames } from '../../app-settings/constants/constants';

export const eventMap = {
  [ACTIVE_TAB_CHANGED]: action => ({
    evid: 11,
    tab_name: biTabNames[action.payload],
  }),
  [BUTTON_CLICKED]: action => ({
    evid: 18,
    button_description: action.payload.name,
  }),
  [LAYOUT_CHANGED]: action => ({
    evid: 13,
    ...action.payload,
  }),
  [DELETE_CATEGORY_REQUEST]: () => ({
    evid: 13,
    selector_type: 'action_button',
    selector_group_name: 'category',
    selected_item_name: 'delete',
  }),
  [CATEGORY_RENAME_STARTED]: () => ({
    evid: 13,
    selector_type: 'action_button',
    selector_group_name: 'category',
    selected_item_name: 'rename',
  }),
  [CATEGORY_EDITED]: () => ({
    evid: 13,
    selector_type: 'action_button',
    selector_group_name: 'category',
    selected_item_name: 'edit',
  }),
  [SHOW_FORUM_FORM]: () => ({
    evid: 13,
    selector_type: 'action_button',
    selector_group_name: 'forum',
    selected_item_name: 'edit',
  }),
  [FORUM_RENAME_STARTED]: () => ({
    evid: 13,
    selector_type: 'action_button',
    selector_group_name: 'forum',
    selected_item_name: 'rename',
  }),
  [CATEGORY_RENAMED]: () => ({
    evid: 18,
    tab_name: 'categories',
    button_description: 'done',
  }),
  [FORUM_RENAMED]: () => ({
    evid: 18,
    tab_name: 'forum',
    button_description: 'done',
  }),
  [TEXTBOX_CHANGED]: action => ({
    evid: 21,
    tab_name: 'categories',
    text_box: action.payload,
    text_input: 'string',
  }),
  [SET_ACTIVE_DESIGN_PAGE]: action => {
    const tab_name = designTabNames[action.payload];
    if (tab_name) {
      return {
        evid: 11,
        tab_name,
      };
    }
  },
};

export const endpoint = 'wixlabs-users';
export const src = 63;



// WEBPACK FOOTER //
// ./app/bi-events/wixlabs-users-events.js